<template>
    <table class="table align-items-center table-custom pb-0 mb-0">
        <thead>
            <tr>
                <th
                    v-for="(heading, index) in tableData.headings"
                    :key="index"
                >
                    {{ heading }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="(data, index) in tableData.datas"
                :key="index"
                class="data-row"
                @click="getSlipData(data.voucher)"
            >
                <th
                    scope="row"
                    v-for="(content, index) in tableData.contents"
                    :key="index"
                >
                    <div class="media d-flex" v-if="content === 'status'">
                        <span class="mb-0 text-md">
                            <span
                                class="status-in"
                                v-if="data[content] === 'in'"
                            >
                                {{
                                    $store.state.language === "en"
                                        ? `${data[content]}`
                                        : "ငွေဝင်"
                                }}
                            </span>
                            <span
                                class="status-out"
                                v-if="data[content] === 'out'"
                            >
                                {{
                                    $store.state.language === "en"
                                        ? `${data[content]}`
                                        : "ငွေထွက်"
                                }}
                            </span>
                            <span v-if="data[content] !== 'in' && data[content] !== 'out'">
                                {{ data[content] || '-' }}
                            </span>
                        </span>
                    </div>

                    <div class="media align-items-center" v-else>
                        <span
                            class="name mb-0 text-md"
                            :class="{ 'amount-cell': content === 'amount' || content === 'current_amount' }"
                        >{{
                            (type === "unitList" && content !== "date"
                                ? Number(data[content]).toLocaleString()
                                : data[content]) || '-'
                        }}</span>
                    </div>
                </th>
            </tr>
            <tr v-if="type === 'unitList'">
                <th scope="row"></th>
                <th scope="row">
                    Total -
                    <b class="amount-cell">{{
                        Number(totalUnitIn()).toLocaleString()
                    }}</b>
                </th>
                <th scope="row">
                    Total -
                    <b class="amount-cell">{{
                        Number(totalUnitOut()).toLocaleString()
                    }}</b>
                </th>
                <th></th>
            </tr>
        </tbody>
    </table>
</template>
<script>
import { DateTime } from 'luxon';

export default {
  props: ['tableData', 'type'],
  methods: {
    getSlipData(voucher) {
      if (voucher) {
        this.$emit('getSlipData', voucher);
      }
    },
    betTime(time) {
      const newTime = new Date(time);
      const targetTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const myanmarDateTime = DateTime.fromJSDate(newTime);
      const targetDateTime = myanmarDateTime.setZone(targetTimeZone);
      const adjustedDrawDate = new Date(targetDateTime.toISO()).toLocaleString('en-US', { timeZone: targetTimeZone });
      return moment(adjustedDrawDate).format('lll');
    },
    totalUnitIn() {
      let total = 0;
      for (let i = 0; i < this.tableData.datas.length; i += 1) {
        total += parseInt(this.tableData.datas[i].unit_in, 10);
      }
      return total;
    },
    totalUnitOut() {
      let total = 0;
      for (let i = 0; i < this.tableData.datas.length; i += 1) {
        total += parseInt(this.tableData.datas[i].unit_out, 10);
      }
      return total;
    },
  },
};
</script>

<style scoped>
.table {
  color: #f0e6c8;
  background: transparent;
}
.table thead th {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  color: #d8c48a;
  font-size: 0.78rem;
  font-weight: 700;
  background: transparent;
  white-space: nowrap;
}
.table th,
.table td {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  color: #f0e6c8;
  background: transparent;
  font-weight: 500;
}
.data-row {
  cursor: pointer;
}
.data-row:active,
.data-row:hover {
  background: #2a2a2a;
}
.amount-cell {
  color: #f7d56a;
  font-weight: 700;
}
.status-in {
  color: #3dd68c;
  font-weight: 700;
  text-transform: capitalize;
}
.status-out {
  color: #ff8a6a;
  font-weight: 700;
  text-transform: capitalize;
}
@media (max-width: 768px) {
    .table-custom {
        display: block;
        overflow-x: auto;
        width: 100%;
        -webkit-overflow-scrolling: touch;
    }
}
</style>
